import { bl_sfa_sales_lead_file_upload_line_RowClass } from "../../../dbschema/bl_sfa_sales_lead_file_upload_line.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaSalesLeadFileUploadLineContainerModel extends BaseContainerModel {
    bl_sfa_sales_lead_file_upload_line: bl_sfa_sales_lead_file_upload_line_RowClass = new bl_sfa_sales_lead_file_upload_line_RowClass()
}